<template>
  <div>
    <el-select
      v-model="sensitiveData.isSensitive"
      :teleported="false"
      placeholder="请选择"
      style="width: 50px"
      @change="handleIsSensitiveChange"
    >
      <el-option v-for="op in isSensitiveOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
    </el-select>
    <el-select
      v-model="sensitiveData.sensitiveTypes"
      :disabled="sensitiveData.isSensitive === 0"
      multiple
      placeholder="请选择"
       :teleported="false"
      style="width: 140px"
      @change="handleInput"
    >
      <el-option v-for="op in sensitiveTypesOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
    </el-select>
    <div
      style="margin: 6px 0px"
      v-if="
        sensitiveData.sensitiveTypes.includes(1) ||
        sensitiveData.sensitiveTypes.includes(2)
      "
    >
      <span>储电容量：</span>
      <el-input-digit
        v-model.number="sensitiveLimitData.maxBatteryCapacity"
        placeholder="请输入"
        nullable
        format="#.#"
        style="width: 120px"
        @input="handleInput"
      >
        <span>Wh</span>
      </el-input-digit>
    </div>
    <div style="margin: 6px 0px" v-if="sensitiveData.sensitiveTypes.includes(4)">
      <span>液体容量：</span>
      <el-input-digit
        v-model.number="sensitiveLimitData.maxLiquidCapacity"
        placeholder="请输入"
        nullable
        format="#.#"
        style="width: 120px"
        @input="handleInput"
      >
        <span>ml</span>
      </el-input-digit>
    </div>
    <div style="margin: 6px 0px" v-if="sensitiveData.sensitiveTypes.includes(7)">
      <span>刀具长度：</span>
      <el-input-digit
        v-model.number="sensitiveLimitData.maxKnifeLength"
        placeholder="请输入"
        nullable
        format="#"
        style="width: 120px"
        @input="handleInput"
      >
        <span>cm</span>
      </el-input-digit>
    </div>
    <div style="margin: 6px 0px" v-if="sensitiveData.sensitiveTypes.includes(7)">
      <span>刀尖角度：</span>
      <el-input-digit
        v-model.number="sensitiveLimitData.knifeTipAngle.degrees"
        placeholder="请输入"
        nullable
        format="#"
        style="width: 120px"
        @input="handleInput"
      >
        <span>度</span>
      </el-input-digit>
    </div>
  </div>
</template>

<script>
import { isSensitiveOpts, sensitiveTypesOpts } from '../../config';

export default {
  name: 'SensitiveAttrInput',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          productSkuSensitiveAttrReq: {
            isSensitive: 0,
            sensitiveTypes: []
          },
          productSkuSensitiveLimitReq: {
            maxBatteryCapacity: '',
            maxLiquidCapacity: '',
            maxKnifeLength: '',
            knifeTipAngle: { degrees: '' }
          }
        };
      }
    }
  },
  data() {
    return {
      isSensitiveOpts,
      sensitiveTypesOpts
    };
  },
  computed: {
    sensitiveData: {
      get() {
        return this.value.productSkuSensitiveAttrReq;
      },
      set(val) {
        this.$emit('change', {
          ...this.value,
          productSkuSensitiveAttrReq: val
        });
      }
    },
    sensitiveLimitData: {
      get() {
        return this.value.productSkuSensitiveLimitReq;
      },
      set(val) {
        this.$emit('change', {
          ...this.value,
          productSkuSensitiveLimitReq: val
        });
      }
    }
  },
  methods: {
    handleIsSensitiveChange() {
      if (this.sensitiveData.isSensitive === 0) {
        this.sensitiveData.sensitiveTypes = [];
      }
      this.handleInput();
    },
    handleInput() {
      this.$emit('change', this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
</style> 